<template>
  <v-row class="align-center">
    <v-col cols="3" class="subtitle-2">Porterage</v-col>
    <v-col>
      <div v-if="value" class="d-flex align-center flex-wrap">
        <span class="mr-2 text-capitalize">{{ formattedMode }}</span>
        <v-text-field
          v-if="value.mode !== 'not offered'"
          v-currency="currency"
          outlined
          hide-details
          dense
          class="mr-2"
          style="max-width: 140px"
          :value="formattedNumber"
          @input="updateValue"
        />
        <pcheck
          v-if="value.mode === 'optional'"
          class="mr-2"
          label="Include"
          :value="!!includeOptional"
          @input="(v) => $emit('include-optional', v)"
        />
        <v-btn icon x-small @click="clear"><v-icon small>clear</v-icon></v-btn>
      </div>
      <div v-else>
        <v-btn
          v-for="opt in options"
          :key="opt.id"
          x-small
          class="mx-1 cyoa-btn"
          color="grey lighten-1"
          @click="add(opt.id)"
        >
          {{ opt.label }}
        </v-btn>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import moneyService from "@/services/money";

export default {
  props: {
    value: Object, // { mode, value, cur }
    includeOptional: Boolean,
  },
  data() {
    return {
      options: [
        { id: "mandatory", label: "Mandatory" },
        { id: "optional", label: "Optional" },
        { id: "not offered", label: "Not Offered" },
      ],
    };
  },
  computed: {
    supplierEnv() {
      return this.$store.getters["SupplierStore/env"];
    },
    currency() {
      const source = moneyService.getCurrencySource(this.supplierEnv);
      return {
        currency: source.currency,
        locale: "en-US",
        prefix: source.currency_symbol,
      };
    },
    formattedMode() {
      return this.value?.mode?.replace("_", " ");
    },
    formattedNumber() {
      if (!this.value?.value) return "";
      return moneyService.stripFormatting(this.value.value, this.supplierEnv);
    },
  },
  methods: {
    add(mode) {
      const payload = mode === "not offered" ? { mode } : { mode, value: 0, cur: this.currency.currency };

      this.$emit("input", payload);
      if (mode === "optional") {
        this.$emit("include-optional", false);
      } else if (mode === "mandatory") {
        this.$emit("include-optional", true);
      } else {
        this.$emit("include-optional", false);
      }
    },
    updateValue(newVal) {
      this.$emit("input", {
        ...this.value,
        value: newVal,
        cur: this.currency.currency,
      });
    },
    clear() {
      this.$emit("input", null);
      this.$emit("include-optional", false);
    },
  },
};
</script>
